import qs from 'qs'

import config from '@app/config'
import { communicationsApi } from '@app/services'

import { FetchConversationMessagesResponse } from './types'

export const fetchConversationMessages = async (
  conversationId: number,
  fromMessageId: number | null,
  count: number,
  signal: AbortSignal
) => {
  const lang = config.regionalSettings?.language
  const doNotTranslateFromLanguages =
    config.regionalSettings?.languageExceptions || []

  const { data } =
    await communicationsApi.get<FetchConversationMessagesResponse>(
      `conversation/${conversationId}/messages`,
      {
        params: {
          count,
          fromMessageId,
          lang,
          direction: 'DESC',
          doNotTranslateFrom: doNotTranslateFromLanguages,
        },
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'repeat' }),
        signal,
      }
    )

  return data
}
